// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xfIm","col":"styles_col__Amm_R"};